export default "//cdn.scentbird.com/assets/frontbird-site/images/desktop_9bf31c.jpg";